import { useCallback } from 'react';
import { QueryableEntityType } from 'mark43-federated-search';
import { useFederatedSearchActions } from '../federated-search-context';

export const useSelectForm = () => {
    const actions = useFederatedSearchActions();

    const selectForm = useCallback((type: QueryableEntityType, field: string) => {
        actions?.setSelectedForm?.(type, field);
    }, [actions]);

    return { selectForm };
};
